import { IconButton, Tooltip } from "@mui/material";
import { QueryStats } from "@mui/icons-material";
import { TOOLTIP_PROPS } from "./internalToolsUtils";
import { useState } from "react";
import styled from "styled-components/macro";

export function VisitCustomerGraphQLLinksDropdown({ ckey }: { ckey: string }) {
  // a QueryStats IconButton that opens a dropdown menu on hover,
  // the menu opens down in a vertical list,
  // when opened, the QueryStats IconButton is replaced with an ArrowDown icon,
  // and below it is rendered a QueryStats IconButton link which opens in a new tab the following links:
  // - Midgard GraphiQL -> https://<ckey>.gke-us-east1.raven-cloud.com/midgard/graphiql/
  // - Askr GraphIQL -> https://<ckey>.gke-us-east1.raven-cloud.com/askr/graphiql/

  const [hovered, setHovered] = useState(false);

  return (
    <Styles
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <Tooltip title={`↗ Midgard GraphiQL`} {...TOOLTIP_PROPS}>
        <IconButton
          size="small"
          onClick={() => {
            window.open(
              `https://${ckey}.gke-us-east1.raven-cloud.com/midgard/graphiql/`,
              "_blank"
            );
          }}
          onMouseEnter={() => {
            setHovered(true);
          }}
        >
          <QueryStats />
        </IconButton>
      </Tooltip>
      {hovered ? (
        <>
          <VisitCustomerAskrGraphiQLLink ckey={ckey} />
        </>
      ) : null}
    </Styles>
  );
}
const Styles = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 20px;
  overflow: visible;
  button {
    background: rgba(255, 255, 255, 0.8);
  }
`;

function VisitCustomerAskrGraphiQLLink({ ckey }: { ckey: string }) {
  return (
    <Tooltip title={`↗ Askr GraphiQL`} {...TOOLTIP_PROPS}>
      <IconButton
        size="small"
        onClick={() => {
          window.open(
            `https://${ckey}.gke-us-east1.raven-cloud.com/askr/graphiql`,
            "_blank"
          );
        }}
      >
        <QueryStats />
      </IconButton>
    </Tooltip>
  );
}
